module.exports = __webpack_public_path__ + "static/media/team1.204f7aa5.jpg";